module.exports = __webpack_public_path__ + "static/media/test.c991d359.jpg";